import { useState } from 'react';
import type { FunctionComponent } from 'react';
import { DefaultThemeProvider } from './themes/default';
import useKonami from 'react-use-konami';
import { useEvent } from 'react-use';
import GameBase from './screens/GameBase.Container';
import Intro from './screens/intro/Intro';
import Concepts from './screens/concept/Concepts.Container';
import Personas from './screens/persona/Personas';
import Overview from './screens/overview/Overview.Container';
import Outro from './screens/outro/Outro';
import ConfigurationOverlay from './debug/ConfigurationOverlay.Container';

const App: FunctionComponent = () => {
	const [configurationOverlayVisible, setConfigurationOverlayVisible] =
		useState(false);
	useKonami(() => setConfigurationOverlayVisible(true));
	useEvent('contextmenu', (e: Event) =>
		// Disables context menu
		e.preventDefault()
	);

	/**
	 * Component hierarchy:
	 *
	 * - [Base] (blurred: yes/no)
	 *     - [Background]
	 *         - Map
	 *         - Concepts Overlay
	 *         - Fog (visible: yes/no)
	 *     - [Personas]
	 *         - Persona Icons (visible: yes/no, enabled: yes/no)
	 *         - Persona Feedback (visible: yes/no)
	 *         - Fog (visible: yes/no)
	 *     - [Toolbars]
	 *         - Seasons Toolbar (visible: yes/no)
	 *         - Concepts Toolbar (visible: yes/no, enabled: yes/no)
	 *         - Score Toolbar (visible: yes/no)
	 *     - [Overlays]
	 *         - Persona Score Change (visible: yes/no)
	 * - [Front]
	 *     - Additional layer based on state/route. e.g. dialog or any other overlay.
	 * - [Special]
	 *     - Configuration Overlay
	 */

	return (
		<DefaultThemeProvider>
			{/* Base */}
			<GameBase>
				{/* Front */}
				<Personas />
				<Concepts />
				<Intro />
				<Overview />
				<Outro />
			</GameBase>
			<ConfigurationOverlay
				visible={configurationOverlayVisible}
				onClose={() => setConfigurationOverlayVisible(false)}
			/>
		</DefaultThemeProvider>
	);
};

export default App;
